import React from "react";
import { Control, useFieldArray, useWatch } from "react-hook-form";
import {
  Button,
  DateTimeController,
  Grid,
  Icons,
  IconButton,
} from "@pushpress/shared-components";
import { useFeatureFlag } from "../../../context/features";
import { RECURRING_APPT_FEATURE_FLAG } from "../../../context/features/features.utils";
import { AppointmentForm } from "./BookAppointmentDrawer.types";
import { getNextWeek } from "./BookAppointmentDrawer.utils";

interface IndividualProps {
  control: Control<AppointmentForm>;
  credits?: number;
}

function Individual(props: IndividualProps) {
  const { control, credits } = props;

  const { isFeatureEnabled } = useFeatureFlag();

  const recurringBookingFlag = isFeatureEnabled(RECURRING_APPT_FEATURE_FLAG);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "when",
  });

  const when = useWatch({ control, name: "when" });

  const handleAddWhen = () => {
    const lastDate = when[when.length - 1].date;
    append({ date: getNextWeek(lastDate) });
  };

  const addDisabled = fields.length >= credits && !recurringBookingFlag;
  const canDelete = fields.length > 1;

  return (
    <>
      {fields.map((field, index) => (
        <Grid key={field.id} container>
          <Grid item xs={11}>
            <DateTimeController
              label="When"
              control={control}
              name={`when.${index}.date`}
              hideLabel
              required
              DateInputProps={{ startIcon: Icons.Classes }}
              TimeInputProps={{ startIcon: Icons.Clock, minuteStep: 5 }}
            />
          </Grid>
          <Grid item xs={1}>
            <IconButton
              icon={Icons.Trash}
              size={16}
              color="#2A3540"
              className="mt-2"
              disabled={!canDelete}
              onClick={() => remove(index)}
            />
          </Grid>
        </Grid>
      ))}
      <Grid container justifyContent="flex-end">
        <Button
          className="mt-1"
          text="Appointment"
          buttonType="secondary"
          type="button"
          icon={Icons.Plus}
          iconLocation="left"
          disabled={addDisabled}
          onClick={handleAddWhen}
        />
      </Grid>
    </>
  );
}

export default Individual;
